export function jibCraneSpan() {
    return 730
}
